import React from "react";
import SysAppLoggerDetails from "../component/SysAppLoggerDetails";

const SysAppLoggerDetailsContainer = () => (<SysAppLoggerDetails />)

export default SysAppLoggerDetailsContainer;
